import React, {useEffect} from "react";
import {liff} from "@line/liff";
import {useTranslation} from "react-i18next";
import "./style.css";

export const ConsultLiff = (): JSX.Element | null => {
    const { t } = useTranslation("consult");
    const [userDisplayName, setUserDisplayName] = React.useState("");
    // 設定回傳錯誤 errorMessages 給用戶
    const [errorMessage, setErrorMessage] = React.useState("");
    const liffId = "2003129313-am10lBrN";

    useEffect(() => {
        const initLiff = async () => {
            try {
                await liff.init({ liffId });
                console.log('LIFF init');
                if (!liff.isLoggedIn()) {
                    liff.login();
                }
                const profile = await liff.getProfile();
                console.log('profile', profile);
                const display = profile.displayName || 'Guest'; // 防止 displayName 为空
                setUserDisplayName(display);
                // 透過 LIFF SDK 發送訊息給用戶
                // await liff.sendMessages([{
                //     type: 'text',
                //     text: `Hello, ${display}!`
                // }]);
                // 關閉 LIFF SDK
                // liff.closeWindow();
            } catch (error: unknown) {
                console.error('Error initializing liff or sending message: ', error);
                if (error instanceof Error) {
                    setErrorMessage(t('liff.errorPrefix') + error.message);
                }
            }
        };
        initLiff();
    }, []);

    if (userDisplayName) {
        return <div>{userDisplayName}</div>; // Return display name to user if there is one
    }
    if (errorMessage) {
        return <div>{errorMessage}</div>; // Return error message to user if there is one
    }

    return <div>{t('liff.loading')}</div>;
};
